import { Typography, Button } from 'antd';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import './CardView.less';
/**
 * @component CardView.tsx
 * @description CardView component
 * @return { Component }
 */
interface CardViewProps {
  color: string;
  text: string;
  icon: React.ReactElement;
  cardOnClick: (item: string, navigate: NavigateFunction) => void;
}
function CardView(props: CardViewProps) {
  const { Title, Text } = Typography;
  const color = props.color;
  let navigate = useNavigate();
  const itemOnclick = () => {
    props.cardOnClick(props.text, navigate);
  };
  return (
    <div onClick={itemOnclick} className="org-card-view__content">
      <Button
        className={`org-card-view__button ${color}`}
        shape="circle"
        type="primary"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
        icon={props.icon}
      />
      <Title level={3}>{props.text}</Title>
      <Text type="secondary">
        Nulla Lorem mollit cupidatat irure. Laborum magna nulla duis ullamco
        cillum dolor. Voluptate exercitation incididunt aliquip deserunt
        reprehenderit elit laborum.
      </Text>
    </div>
  );
}

export default CardView;
